import { createSlice } from "@reduxjs/toolkit";

interface FiltersState {
  showFilters: boolean;
}

const initialState: FiltersState = {
  showFilters: false,
};

const showFiltersSlice = createSlice({
  name: "showFilters",
  initialState,
  reducers: {
    toggleFilters: (state) => {
      state.showFilters = !state.showFilters;
    },
    setFilters: (state, action) => {
      state.showFilters = action.payload;
    },
  },
});

export const { toggleFilters, setFilters } = showFiltersSlice.actions;
export default showFiltersSlice.reducer;
